/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { EventStatsDto } from '../../models/event-stats-dto';

export interface AdminStatsControllerGetEventStats$Params {
}

export function adminStatsControllerGetEventStats(http: HttpClient, rootUrl: string, params?: AdminStatsControllerGetEventStats$Params, context?: HttpContext): Observable<StrictHttpResponse<EventStatsDto>> {
  const rb = new RequestBuilder(rootUrl, adminStatsControllerGetEventStats.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<EventStatsDto>;
    })
  );
}

adminStatsControllerGetEventStats.PATH = '/admin-stats/events';
